import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why great engineers hack The Process",
  "description": "",
  "published": "2020-03-03T00:00:00.000Z",
  "redirect_from": ["/blog/why-great-engineers-hack-the-process/swizec/9344"],
  "categories": "Opinions",
  "hero": "./img/techletter.app-screenshot-1583251183664.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1230257618980986880"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.017937219730946%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'208\\'%20viewBox=\\'0%200%20400%20208\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2016c-15%206-12%2026%204%2028%206%201%2014-4%209-6-5-1-3-5%202-5%202%200%204-2%204-5%200-8-11-15-19-12\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7a37492addbd6b482e5c6148035ec059/ca0a1/techletter.app-screenshot-1583251183664.webp 223w", "/static/7a37492addbd6b482e5c6148035ec059/75680/techletter.app-screenshot-1583251183664.webp 445w", "/static/7a37492addbd6b482e5c6148035ec059/0ba47/techletter.app-screenshot-1583251183664.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7a37492addbd6b482e5c6148035ec059/e92b6/techletter.app-screenshot-1583251183664.png 223w", "/static/7a37492addbd6b482e5c6148035ec059/e66bf/techletter.app-screenshot-1583251183664.png 445w", "/static/7a37492addbd6b482e5c6148035ec059/6af66/techletter.app-screenshot-1583251183664.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7a37492addbd6b482e5c6148035ec059/6af66/techletter.app-screenshot-1583251183664.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Companies start life in the cowboy phase – a band of brothers and sisters building something cool.`}</p>
    <p>{`You ship straight to prod, you understand the whole business, you vibe with everyone around you. They think it, you build it. Telepathic almost.`}</p>
    <p>{`When something goes wrong, you know how to fix it. The whole system fits in your head. You know what everyone is working on, and you Just Know™ what matters most.`}</p>
    <p>{`Life is good. An engineer's dream.`}</p>
    <p><img parentName="p" {...{
        "src": "/12eee708b5e0bc2f319915d405f2633d/media-YQitE4YNQNahy-giphy-downsized-medium.gif",
        "alt": "hacker giphy"
      }}></img></p>
    <p>{`Then something goes wrong.`}</p>
    <p>{`You push a critical bug. Production goes down. Customers lose data. Thanksgiving promotions don't work. The site crashes at a pitch to investors. Money is lost.`}</p>
    <p>{`Time to grow up.`}</p>
    <h2 {...{
      "id": "a-process-is-born"
    }}>{`A process is born`}</h2>
    <p>{`You add checks and balances.`}</p>
    <p>{`Something simple – everyone's code needs to go through a pull request. Helps you know what's going on, increases team learnings, ensures at least two people see every change.`}</p>
    <p>{`Great idea!`}</p>
    <p>{`Then you add QA, product managers, designers, feature owners, internal clients, external clients, this person that person ... before you know it every idea goes through committee after committee before it even reaches the developer.`}</p>
    <h2 {...{
      "id": "nothing-gets-done-anymore"
    }}>{`Nothing gets done anymore`}</h2>
    <p>{`3 or 4 years after starting, if you're not careful, most of your time goes to meta work. Work about work.`}</p>
    <p>{`You have an idea. Tell the PM.`}</p>
    <p>{`PM puts it on their pile of ideas.`}</p>
    <p><img parentName="p" {...{
        "src": "/5a1379a2e5e0cf80ca7b61ee2b1c872a/media-5XrhgZ7mFBrMc-giphy.gif",
        "alt": "pile_of_shit giphy"
      }}></img></p>
    <p>{`Every Friday, your PM – now called Head of Product because you're a very real grownup company – looks at this list and decides what to work on.`}</p>
    <p>{`Your idea might just align with business objectives.`}</p>
    <p>{`PM looks at everyone touched by this idea and goes into Requirements Gathering mode. They talk to sales, customer support, operations, engineering, the CEO, the COO, the janitor, and maybe that homeless dude outside.`}</p>
    <p>{`3 weeks later a spec is born.`}</p>
    <p>{`5 miles long, covering all edge cases, and with everyone's pet addition. Your idea is on line 5 paragraph 6. Now unrecognizable.`}</p>
    <h2 {...{
      "id": "you-get-to-work"
    }}>{`You get to work`}</h2>
    <p>{`Work starts with reviewing the spec. You talk to the PM ask a bunch of questions, poke holes in the edge cases, talk to the clients again just to make sure everyone understands the spec in the same way.`}</p>
    <p>{`Everyone had a new idea. That little something they forgot.`}</p>
    <p>{`The spec grows a mile.`}</p>
    <p>{`You create a detailed estimate. Line by line. Investigate the code, plan the solution, really dig down to what's needed. Hand waving with an `}<em parentName="p">{`"Eh about 5 days"`}</em>{` won't do in a serious grownup organization like yours.`}</p>
    <p>{`It takes you 3 days to dig through the requirements, the aging codebase, and the technical debt. You're pretty sure you know how to implement this.`}</p>
    <p>{`Estimate: 5 days.`}</p>
    <p>{`You spend another 2 days writing test cases for QA, help docs for feature testing, and some documentation for yourself. Gotta know how you'll know the feature works before you start. Them's the rules.`}</p>
    <h2 {...{
      "id": "code-is-just-a-checklist"
    }}>{`Code is just a checklist`}</h2>
    <p>{`You finally get to code. 2 weeks since you started the project.`}</p>
    <p>{`Ah bliss`}</p>
    <p>{`Except your estimate is so detailed that there's no fun left. You're just following a checklist. A detailed list of steps pre-determined while estimating.`}</p>
    <p>{`You've done the engineering. The fun stuff. Now you're just doing work. Like digging a trench.`}</p>
    <p><img parentName="p" {...{
        "src": "/fce5dcd21e0d6e9cdb1d0a74118aa3ab/media-3oEjHCFnOk8cNjdSz6-giphy.gif",
        "alt": "dig_a_hole giphy"
      }}></img></p>
    <h2 {...{
      "id": "time-to-deploy"
    }}>{`Time to deploy`}</h2>
    <p>{`10 days later you're ready to deploy.`}</p>
    <p>{`Oh the estimate was 5? Ha! You forgot work takes `}<em parentName="p">{`work`}</em>{`. Even if it's simple, easy, and following a checklist, it still takes time.`}</p>
    <p>{`Frustrating, I know.`}</p>
    <p>{`You send a pull request to the 5 repositories you changed. Ship off to QA. And ask the PM to verify everything looks good.`}</p>
    <p>{`Five hundred comments and 3 feature additions later, you're ready to ship.`}</p>
    <p>{`That took another week.`}</p>
    <p>{`5 months from idea to feature but at least your deployment process is easy. You're a young startup after all!`}</p>
    <p>{`Just poke the deployment engineer and she'll get to it tomorrow.`}</p>
    <p>{`Maybe.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      